import React from 'react';
import { CheckIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { BUSINESS } from '../data/i18n';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const points = ['about.point1', 'about.point2', 'about.point3'];
export function About() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="w-full bg-white py-20 sm:py-24" data-id="element-2" data-mp="2ypsn703ov120">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 sm:px-6 lg:grid-cols-[1.1fr_0.9fr] lg:items-center lg:gap-16 lg:px-8" data-id="element-3" data-mp="33qqa1pzn8j9u">
        <Reveal data-id="element-4" data-mp="3dhb8ndfbhnsr">
          <div data-id="element-5" data-mp="3dgjfe997025n">
            <SectionHeading eyebrow={t('about.eyebrow')} title={t('about.title')} data-id="element-6" data-mp="3di47ztby5b0v" />
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-navy-900/70" data-id="element-7" data-mp="3hiwg2j9319vk">
              {t('about.body')}
            </p>
            <ul className="mt-7 flex flex-col gap-3" data-id="element-8" data-mp="3mjas0cdt13yv">
              {points.map(key => <li key={key} className="flex items-start gap-3" data-id="element-9" data-mp="3rhc8cpjuip6n">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest-600 text-white" data-id="element-10" data-mp="2lrh8vv72wf96">
                    <CheckIcon className="h-3 w-3" strokeWidth={3} aria-hidden="true" data-id="element-11" data-mp="2gqkv8pwxdeqk" />
                  </span>
                  <span className="text-[15px] font-semibold text-navy-900" data-id="element-12" data-mp="2cqstox5y88up">{t(key)}</span>
                </li>)}
            </ul>
            <a href={BUSINESS.phoneHref} className="mt-8 inline-flex items-center gap-2 rounded-md bg-navy-900 px-6 py-3.5 font-display text-sm font-bold text-white transition-[background-color,transform] duration-150 ease-smooth hover:bg-brand-600 active:scale-[0.98]" data-id="element-13" data-mp="34i8dkjg4fhh8">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-14" data-mp="2qr3k5z3cjlfc" />
              {BUSINESS.phoneDisplay}
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.08} data-id="element-15" data-mp="3o7sl7qkh2jno">
          <figure className="overflow-hidden rounded-2xl border border-navy-900/10 shadow-card" data-id="element-16" data-mp="3jf944jmkt6e4">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/41f71773-755b-44c2-a6e7-27ed04b4d633.jpg" alt="Completed exterior remodel with new siding and trim by JV Home Service" loading="lazy" className="aspect-[4/3] w-full object-cover" data-id="element-17" data-mp="663oc743apn7" />
            <figcaption className="bg-navy-900 px-6 py-5" data-id="element-18" data-mp="1e29cdfjekth">
              <span className="block font-display text-sm font-bold text-white" data-id="element-19" data-mp="3jkqc3wn46vvz">
                {BUSINESS.owner} — {BUSINESS.name}
              </span>
              <span className="mt-1 block text-sm text-white/70" data-id="element-20" data-mp="3olec37tbmn2c">{BUSINESS.area}</span>
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>;
}